export default __webpack_public_path__ + "static/media/m2.2439f335.png";